import { render, staticRenderFns } from "./ProductsInCart.vue?vue&type=template&id=8438e3e8&"
import script from "./ProductsInCart.vue?vue&type=script&lang=ts&"
export * from "./ProductsInCart.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsInCart.vue?vue&type=style&index=0&id=8438e3e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports